import Factory from './utils/factory'

export default Factory({
  id: null,
  title: null,
  description: null,
  settings: null,
  fields: null,
  receivers: [{ user: '' }],
  placement: [],
})
